/* eslint-disable */
export const TEACHER_LOGIN = `
mutation($account: String!, $password: String!) {
  teacherLogin(account: $account, password: $password) {
    token
    account{
      id
      name
      phone
    }
  }
}`;

export const STUDENT_LIST = `
query ($studentName: String, $date: String){
  studentList(studentName: $studentName, date: $date) {
    onBoardNum
    schoolName
    alterMessage
    list{
      id
      name
      description
      time
    }
  }
}`;
